module.exports = __webpack_public_path__ + "img/bar_logo.7b51bdf7.svg";